import React from 'react';
import { inject, observer } from 'mobx-react';
import debounce from 'lodash/debounce';
import {
  Modal, Input, Icon, Button, Table, Select, Spin,
} from 'antd';
import './style/cus.less';
import { toJS } from 'mobx';

const Search = Input.Search;
const Option = Select.Option;
@inject('modeListStore')
@observer
class CustomerButtonNew extends React.Component {
  static defaultProps = {
    prefixCls: 'customerButton',
  }
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      fetching: false,
      selectedValue: [],
      search: '', // 客户浏览框内部搜索框
      showTable: false,
    }
  }
  componentWillReceiveProps(nextProps) {
    const { value, modeListStore: { cusList } } = this.props;
    let params = { selectedValue: [], search: '', showTable: false };
    if (nextProps.value !== value && nextProps.value) {
      const searchData = toJS(cusList).find((cus) => cus.id === nextProps.value.toString());
      if (searchData) {
        params = { selectedValue: [{ key: searchData.id, label: searchData.name, }], search: searchData.name, showTable: true };
      }
      this.setState(params);
    } else if (nextProps.value !== value && nextProps.value === '') {
      this.setState(params);
    }
  }
  componentWillUnMount() {
    this.setState({ visible: false });
  }
  onCancel = () => { // 关闭客户浏览框
    this.setState({ visible: false });
    const { modeListStore: { setMobxState } } = this.props;
    setMobxState({ cusCurrent: 1 });
  }
  setSearchValue = (value) => { // 设置搜索条件
    this.setState({ search: value });
  }
  onPageChange = (page) => { // 切页
    const { search } = this.state;
    const { modeListStore: { getDeV2 } } = this.props;
    if (search) {
      getDeV2({ current: page, search });
    }
  }
  onSearch = () => { // 获取客户数据
    const { search } = this.state;
    const { modeListStore: { getDeV2, cusCurrent } } = this.props;
    this.setState({ showTable: true, fetching: true });
    if (search) {
      getDeV2({ current: cusCurrent, search }).then(() => {
        this.setState({ fetching: false });
      });
    }
  }
  onRow = (record) => { // 行选中
    return {
      onClick: (e) => {
        this.setState({ selectedValue: [{ key: record.id || record.key, label: record.name || record.label }] });
        // this.setState({ valueSpan: record.name || record.label, selectedValue: [{ key: record.id || record.key, label: record.name || record.label }] });
        typeof this.props.onChange && this.props.onChange(record.id || record.key, record || {});
        this.onCancel();
      }
    }
  }
  onSelectChange = (value) => { // 联想搜索
    const { modeListStore: { setMobxState } } = this.props;
    const { selectedValue } = this.state;
    const res = value.filter((v) => !selectedValue.find((k) => k.key === v.key));
    this.setState({ selectedValue: res }); // 单选
    const ids = res.map((v) => v.key).join();
    typeof this.props.onChange && this.props.onChange(ids, res[0] || {}); // 数据受控
    if (res && res.length === 0) { // 清空选项
      setMobxState({ cusList: [], cusCount: 0, cusCurrent: 1, showTable: false, search: '' });
    }
  }
  fetchUser = (value) => {
    const { modeListStore: { getDeV2 } } = this.props;
    this.setState({ fetching: true });
    getDeV2({ search: value }).then(() => {
      this.setState({ fetching: false });
    });
  }
  render() {
    const { prefixCls, disabled, modeListStore: { cusList, cusCount, cusCurrent } } = this.props;
    const { selectedValue, visible, fetching, search, showTable } = this.state;
    const columns = [
      { title: '客户名称', dataIndex: 'name', key: 'name', },
      { title: '客户经理', dataIndex: 'username', key: 'username', },
    ];
    const datas = toJS(cusList);
    return (
      <div className={`${prefixCls} ${prefixCls}${disabled ? '-disabled' : ''}`}>
        {/* <input hidden={true} value={valueSpan} onChange={() => null} readOnly /> */}
        <Select
          className={`${prefixCls}-searchSelect`}
          disabled={disabled}
          mode="multiple"
          loading={fetching}
          labelInValue
          value={selectedValue}
          placeholder="请输入客户名称"
          notFoundContent={fetching ? <Spin size="small" /> : null}
          filterOption={false}
          onSearch={debounce(this.fetchUser, 400)}
          onChange={this.onSelectChange}
        >
          {
            datas && datas.map((data) => (
              <Option key={data.id}>
                {data.name}
              </Option>
            ))
          }
        </Select>
        <Button icon="search" disabled={disabled} className={`${prefixCls}-searchBtn`} onClick={() => !disabled && this.setState({ visible: true })} />
        <Modal
          title="客户"
          className={`${prefixCls}-cusModal`}
          visible={visible}
          onCancel={this.onCancel}
          maskClosable={false}
          width={700}
          footer={[
            <Button key="cusCancel" onClick={this.onCancel}>返回</Button>
          ]}
        >
          {
            showTable ? [
              <div className={`${prefixCls}-cusModal-search`} key="customeButtonNew-table-search">
                <Search value={search} placeholder="请先输入客户名称" onChange={(e) => this.setSearchValue(e.target.value)} onSearch={this.onSearch} />
              </div>,
              <Table
                key="customeButtonNew-table"
                rowKey="id"
                columns={columns}
                dataSource={datas}
                size="middle"
                loading={fetching}
                pagination={{
                  total: cusCount,
                  current: cusCurrent,
                  onChange: this.onPageChange,
                  pageSize: 10
                }}
                locale={{
                  emptyText:
                    <div style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.43)', textAlign: 'center' }}>
                      <Icon type="frown-o" />
                      <span style={{ marginLeft: 4 }}>暂无数据</span>
                    </div>
                }}
                onRow={this.onRow}
              />
            ] : (
              <div className={`${prefixCls}-cusModal-search-input`}>
                <div className={`${prefixCls}-cusModal-search-input-title`}>
                  <Icon type="search" /><span>客户</span>
                </div>
                <Search value={search} placeholder="请先输入客户名称" onChange={(e) => this.setSearchValue(e.target.value)} onSearch={this.onSearch} />
              </div>
            )
          }
        </Modal>
      </div>
    )
  }
}

export default CustomerButtonNew;


// WEBPACK FOOTER //
// ./src/components/util/appApply/CustomerButtonNew.js